import LookupRequestModelBase from '../_generated/modelBases/lookup-request-model-base';

export default class LookupRequestModel extends LookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
